var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1386,
    height: 833,
    viewBox: "0 0 1386 833",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10033_38386)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1386,
    height: 833,
    transform: "matrix(-1 0 0 1 1386 0)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1386 567.899L1339.8 557.764C1293.6 547.49 1201.2 527.22 1108.8 504.729C1016.4 482.238 960.906 481.822 868.506 504.729C776.106 527.637 646.8 573.868 554.4 615.796C462 657.724 369.6 671.052 277.2 627.181C184.8 583.17 92.3999 481.822 46.2 431.148L0 380.474V834.459H46.2C92.3999 834.459 184.8 834.459 277.2 834.459C369.6 834.459 462 834.459 554.4 834.459C646.8 834.459 739.2 834.459 831.6 834.459C924 834.459 1016.4 834.459 1108.8 834.459C1201.2 834.459 1293.6 834.459 1339.8 834.459H1386V567.899Z",
    fill: "url(#paint0_linear_10033_38386)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1586.32 558.848L1522.16 582.471C1458.01 606.093 1329.69 653.338 1201.38 652.365C1073.07 651.532 944.754 602.341 816.441 600.118C688.127 597.756 559.814 642.222 431.501 671.819C303.188 701.556 174.874 716.285 46.5609 719.064C-81.7524 721.843 -191.771 698.56 -236.881 671.819L-338.379 613.327V857.603H-274.222C-210.066 857.603 -81.7524 857.603 46.5609 857.603C174.874 857.603 303.188 857.603 431.501 857.603C559.814 857.603 688.127 857.603 816.441 857.603C944.754 857.603 1073.07 857.603 1201.38 857.603C1329.69 857.603 1458.01 857.603 1522.16 857.603H1586.32V558.848Z",
    fill: "url(#paint1_linear_10033_38386)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1586.32 719.906L1533.44 736.319C1480.57 752.87 1374.81 785.695 1269.06 772.343C1163.3 758.851 1057.55 699.043 951.792 674.425C846.037 649.945 740.283 660.516 634.528 689.307C528.773 718.098 423.019 764.832 317.264 766.918C211.509 769.004 105.755 726.444 52.8773 705.024L0 683.744V857.603H52.8773C105.755 857.603 211.509 857.603 317.264 857.603C423.019 857.603 528.773 857.603 634.528 857.603C740.283 857.603 846.037 857.603 951.792 857.603C1057.55 857.603 1163.3 857.603 1269.06 857.603C1374.81 857.603 1480.57 857.603 1533.44 857.603H1586.32V719.906Z",
    fill: "url(#paint2_linear_10033_38386)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1799.27 786.966L1737.04 806.382C1674.81 825.963 1550.35 864.796 1425.88 848.999C1301.42 833.038 1176.96 762.284 1052.49 733.159C928.03 704.199 803.567 716.704 679.104 750.765C554.641 784.826 430.177 840.114 305.714 842.582C181.251 845.05 56.7875 794.699 -5.44409 769.359L-67.6758 744.184V949.866H-5.44409C56.7875 949.866 181.251 949.866 305.714 949.866C430.177 949.866 554.641 949.866 679.104 949.866C803.567 949.866 928.03 949.866 1052.49 949.866C1176.96 949.866 1301.42 949.866 1425.88 949.866C1550.35 949.866 1674.81 949.866 1737.04 949.866H1799.27V786.966Z",
    fill: "white",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10033_38386",
    x1: 693,
    y1: 810.224,
    x2: 802.889,
    y2: 379.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10033_38386",
    x1: 1119.81,
    y1: 789.065,
    x2: 1136.5,
    y2: 403.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFD0D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10033_38386",
    x1: 793.16,
    y1: 660.776,
    x2: 793.16,
    y2: 857.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEFF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10033_38386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1386,
    height: 833,
    fill: "white",
    transform: "matrix(-1 0 0 1 1386 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave2);
export default __webpack_public_path__ + "static/media/wave2.53abdd0670b49bd345d442ce3bdc2594.svg";
export { ForwardRef as ReactComponent };